import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import RollcallApplyLeave from "./ApplyLeave";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  Edit,
  Repeat,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Swal from "sweetalert2";
import EditLeave from "./editleave";

const RollCallLeaves = () => {
  const [selectedYear, Setselectedyear] = useState(new Date().getFullYear());
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [loadingss, setLoadingss] = useState(false);
  const [data, setData] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isInitialFetchDone, setIsInitialFetchDone] = useState(false);
  // const [filterData, setFiltereddata] = useState([]);
  const [datas, setDatas] = useState([]);
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  const [editObj, setEditObj] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const [editform, seteditform] = useState({
    leaveid: "",
    regid: "",
    status: "",
    comments: "",
    Username: "",
  });

  useEffect(() => {
    if (editform) {
      setSelectedStatus(editform.status);
    }
  }, [editform]);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const hasFetchedRef = useRef(false);

  const fetchEmployeeData = async () => {
    if (!tokenData || !superIdData) return;
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    const EMP_SESSION_KEY = `employees_${superIdData}`;

    try {
      const sessionEmployees = sessionStorage.getItem(EMP_SESSION_KEY);

      if (sessionEmployees) {
        const parsedEmployees = JSON.parse(sessionEmployees);
        setEmployees(parsedEmployees);
        return;
      }
    } catch (err) {
      console.error("Invalid session data, clearing it", err);
      sessionStorage.removeItem(EMP_SESSION_KEY);
    }

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployees?superid=${superIdData}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) throw new Error("Failed to fetch employees");

      const data = await response.json();

      if (data.status) {
        const empList = data.ResultData || [];
        setEmployees(empList);

        sessionStorage.setItem(EMP_SESSION_KEY, JSON.stringify(empList));
      } else {
        console.error("Error fetching employees:", data.ErrorMsg);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, [tokenData, superIdData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    seteditform((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const empOptions = employees?.map((emp) => ({
    value: emp.RegId,
    label: emp.UserName,
  }));

  const handleLeavesView = async () => {
    if (!superIdData || !tokenData) {
      console.warn("Missing required parameters. Skipping API call.");
      return;
    }
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();

      if (selectedEmp) queryParams.append("regid", selectedEmp);
      if (selectedYear) queryParams.append("year", selectedYear);
      if (superIdData) queryParams.append("superid", superIdData);

      const url = `${ROLL_CALL_API_BASE_URL}portal/leave/getempleaves?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
      });

      const data = await response.json();

      if (response.ok && data?.status) {
        setData(data.ResultData ?? []);
      } else {
        console.error("API Error:", data?.ErrorMsg ?? response.statusText);
      }
    } catch (error) {
      console.error("Network Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tokenData && superIdData && !isInitialFetchDone) {
      handleLeavesView();
      setIsInitialFetchDone(true);
    }
  }, [tokenData, superIdData, isInitialFetchDone]);

  useEffect(() => {
    if (tokenData && superIdData && selectedEmp) {
      handleLeavesView();
    }
  }, [selectedEmp]);

  useEffect(() => {}, [data]);

  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Comments && item.Comments.toLowerCase()) ||
      (item.LvCode && item.LvCode.toString())
    );
  });

  const Statusoptions = [
    { label: "Pending", value: 1 },
    { label: "Approved", value: 2 },
    { label: "Rejected", value: 3 },
  ];

  const yearOptions = Array.from({ length: 4 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  })).reverse();

  const columns = [
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
      render: (text) => (
        <span>{text?.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
      ),
    },
    {
      title: "Bio ID",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId?.length - b.CardId?.length,
    },
    {
      title: "Leaves Avail",
      dataIndex: "LvType",
      sorter: (a, b) => a.LvType?.length - b.LvType?.length,
    },
    {
      title: "Start Dt",
      dataIndex: "StartDt",
      sorter: (a, b) => new Date(a.StartDt) - new Date(b.StartDt),
      render: (text) => {
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "End Dt",
      dataIndex: "EndDt",
      sorter: (a, b) => new Date(a.EndDt) - new Date(b.EndDt),
      render: (text) => {
        const date = new Date(text);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: "Duration",
      dataIndex: "LeaveCount",
      sorter: (a, b) => a.LeaveCount?.length - b.LeaveCount?.length,
    },
    {
      title: "Reason",
      dataIndex: "Comments",
      sorter: (a, b) => (a.Comments?.length || 0) - (b.Comments?.length || 0),
      render: (text) => (
        <span title={text}>
          {text?.length > 13 ? `${text.substring(0, 13)}...` : text}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const statusMap = {
          1: { label: "Pending", className: "badge bg-warning" },
          2: { label: "Approved", className: "badge bg-success" },
          3: { label: "Declined", className: "badge  bg-danger" },
        };

        const current = statusMap[status] || {
          label: "Approved",
          className: "badge bg-success",
        };

        return (
          <span className={`badge ${current.className} shadow-none`}>
            {current.label}
          </span>
        );
      },
      sorter: (a, b) => a.status - b.status,
    },
  ];

  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (__, record) => (
        <div className="action-table-data d-flex justify-content-center">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              title="Edit"
              onClick={() => {
                handelShowEdit(record);
              }}
            >
              <Edit className="feather-edit text-info" />
            </Link>
          </div>
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              title="Status update"
              onClick={() => {
                handelShowUpdateStatus(record);
              }}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightEditLeaveType"
              aria-controls="offcanvasRightEditLeaveType"
            >
              <Repeat className="feather-edit text-info" />
            </Link>
          </div>
        </div>
      ),
    });
  }

  const handelShowUpdateStatus = (record) => {
    seteditform({
      status: record.status,
      leaveid: record.Id,
      regid: record.RegId,
      comments: record.Comments,
      Username: record.UserName,
    });
  };

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const resetData = () => {
    seteditform({
      leaveid: "",
      regid: "",
      status: "",
      comments: "",
      Username: "",
    });

    setIsInitialFetchDone(false);
  };

  useEffect(() => {
    const handleLeavesViews = async () => {
      if (editform.regid) {
        setLoadingss(true);
        if (tokenData) {
          try {
            const response = await fetch(
              `${ROLL_CALL_API_BASE_URL}portal/leave/getleavesummary?regid=${editform.regid}&year=${currentYear}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenData}`,
                },
              },
            );

            const data = await response.json();

            if (data?.status) {
              setDatas(data.ResultData || []);
            } else {
              console.error(
                "Failed to fetch employees:",
                data?.ErrorMsg || response.statusText,
              );
            }
          } catch (error) {
            console.error("Error fetching employees:", error.message);
          } finally {
            setLoadingss(false);
          }
        }
      }
    };
    handleLeavesViews();
  }, [editform.regid]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoadings(true);
    if (tokenData && superIdData) {
      if (selectedStatus === null) {
        Swal.fire("Warning", "Please select a status.", "warning");
        setLoadings(false);
        return;
      }

      const payload = {
        status: selectedStatus,
        leaveid: editform.leaveid,
        regid: editform.regid,
        comments: editform.comments,
      };

      try {
        const res = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/updateleavestatus`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify(payload),
          },
        );
        const result = await res.json();
        if (result?.status) {
          Swal.fire({
            title: "Success!",
            text: "Leave details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            handleLeavesView();
            setIsInitialFetchDone(false);
            resetData();
            document
              .querySelector("#offcanvasRightEditLeaveType .btn-close")
              .click();
          });
        } else {
          Swal.fire("Error", result?.Message || "Update failed.", "error");
        }
      } catch (error) {
        console.error("Update failed:", error);
        Swal.fire("Error", "Something went wrong while updating.", "error");
      } finally {
        setLoadings(false);
      }
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData?.map((item, index) => ({
      "S.No": index + 1,
      Name: item.UserName || "N/A",
      "Bio ID": item.CardId || "N/A",
      "Leaves Avail": item.LvType || "N/A",
      "Leaves Taken": item.LeaveCount || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Leave Data");
    XLSX.writeFile(wb, "Leave_Data.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Leave Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Name",
      "Bio ID",
      "Leaves Avail",
      "Leaves Taken",
    ];
    const tableRows = filteredData?.map((item, index) => [
      index + 1,
      item.UserName || "N/A",
      item.CardId || "N/A",
      item.LvType || "N/A",
      item.LeaveCount || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Leave_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightEditLeaveType");

    const handleOffcanvasClose = () => {
      resetData();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose,
        );
      }
    };
  }, []);

  const handleSort = (key) => {
    const sorted = [...datas].sort((a, b) => {
      if (typeof a[key] === "number") return a[key] - b[key];
      return a[key].toString().localeCompare(b[key].toString());
    });
    const withSno = sorted?.map((item, index) => ({
      ...item,
      sno: index + 1,
    }));

    setDatas(withSno);
  };

  // const statusMap = {
  //   1: { label: "Pending", className: "badge bg-warning" },
  //   2: { label: "Accepted", className: "badge bg-success" },
  //   3: { label: "Declined", className: "badge bg-danger" },
  // };

  const updateLeaveInState = (updatedEmp) => {
    setLoading(true);

    setTimeout(() => {
      setData((prev) =>
        prev.map((emp) =>
          emp.RegId === updatedEmp.RegId ? { ...emp, ...updatedEmp } : emp,
        ),
      );

      setLoading(false);
    }, 100);
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Leaves
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Leaves employees</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  title="Apply Leave"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4 "></i>
                </Link>
              </div>
            )}
          </div>
          {/* /product list */}
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex right-content align-items-end row">
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 180 }}
                  >
                    <div className="col-4">
                      <Select
                        showSearch
                        placeholder="Choose Employee"
                        value={selectedEmp}
                        onChange={setSelectedEmp}
                        options={empOptions}
                        allowClear
                        className="basic-single"
                        classNamePrefix="select"
                        style={{ width: 170, height: 37 }}
                        // filterOption={(input, option) =>
                        //   option.label.toLowerCase().includes(input.toLowerCase())
                        // }
                      />
                    </div>
                  </div>
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 100 }}
                  >
                    <div className="col-3">
                      <Select
                        classNamePrefix="select"
                        className="basic-single"
                        options={yearOptions}
                        placeholder="Year"
                        value={selectedYear}
                        onChange={Setselectedyear}
                        style={{ width: 100, height: 37 }}
                      />
                    </div>
                  </div>

                  <div className="col-2">
                    <button
                      className="btn btn-primary"
                      onClick={handleLeavesView}
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive brand-table">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <div className="table-responsive brand-table">
                      <Table
                        columns={columns}
                        dataSource={filteredData}
                        pgno={true}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightEditLeaveType {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditLeaveType {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditLeaveType {
            width: 35% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditLeaveType {
            width: 22% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditLeaveType {
            width:18% !important;
          }
        }
        `}
      </style>

      <div
        className="offcanvas offcanvas-end d-flex flex-column hide-search-offcanvas"
        tabIndex={-1}
        id="offcanvasRightEditLeaveType"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Leave</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />

        {/* Wrap offcanvas-body and table in a scrollable area */}
        <div
          className="d-flex flex-column flex-grow-1"
          style={{ overflow: "hidden" }}
        >
          <div className="offcanvas-body" style={{ overflow: "visible" }}>
            <form onSubmit={handleUpdate}>
              <div className="content">
                <div className="row">
                  <div className="col-6 mb-1">
                    <label className="form-label">Employee Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editform?.Username}
                      readOnly
                    />
                  </div>
                  <div className="col-6 mb-1">
                    <label className="form-label">Status</label>
                    <Select
                      placeholder="Status"
                      value={selectedStatus}
                      onChange={setSelectedStatus}
                      options={Statusoptions}
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-12 mb-1">
                    <label className="form-label">Comment</label>
                    <textarea
                      type="text"
                      name="comments"
                      className="form-control"
                      value={editform?.comments}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary d-flex mt-3 me-2"
                    data-bs-dismiss="offcanvas"
                    onClick={resetData}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary d-flex mt-3"
                    disabled={loadings}
                  >
                    {loadings ? "Updating.." : "Update"}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div style={{ overflowY: "auto", flexGrow: 1 }}>
            <h4 className="px-3 pt-3">Employee Leaves</h4>
            <div className=" brand-table px-3">
              {loadingss ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : (
                <table
                  className="table table-striped"
                  style={{ borderSpacing: "0px" }}
                >
                  <thead>
                    <tr>
                      <th
                        onClick={() => handleSort("sno")}
                        style={{ cursor: "pointer", padding: "5px 8px" }}
                      >
                        No
                      </th>
                      <th
                        onClick={() => handleSort("LeaveTypeName")}
                        style={{ cursor: "pointer", padding: "5px 8px" }}
                      >
                        Type
                      </th>
                      <th
                        onClick={() => handleSort("Balance")}
                        style={{ cursor: "pointer", padding: "5px 8px" }}
                      >
                        Avail
                      </th>
                      <th
                        onClick={() => handleSort("Taken")}
                        style={{ cursor: "pointer" }}
                      >
                        Taken
                      </th>
                      {/* <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                        Status
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {datas?.length ? (
                      datas?.map((row, i) => {
                        // const st = statusMap[row.status] || {
                        //   label: "Unknown",
                        //   className: "badge bg-secondary",
                        // };
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{row.LeaveTypeName}</td>
                            <td>{row.Balance}</td>
                            <td>{row.Taken}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>

      <RollcallApplyLeave
        isOpen={showAdd}
        handleLeavesView={handleLeavesView}
        onClose={() => setShowAdd(false)}
      />

      <EditLeave
        isOpen={showEdit}
        editObj={editObj}
        onUpdateSuccess={updateLeaveInState}
        onClose={() => setShowEdit(false)}
      />
      {/* <EditLeave editObj={editObj} /> */}
    </div>
  );
};

export default RollCallLeaves;
